const common: Record<string, string> = {
  'nav.selectCategory': 'Выберите категорию',
  'nav.yoybuySheet': 'yoybuy sheet',
  'nav.buyItNow': 'buy it now',
  'nav.allCategories': 'Все категории',
  'footer.brand': 'YOYBUYFINDS',
  'footer.description': 'Ваш надёжный источник curated подборок товаров из Китая. Мы помогаем находить лучшие spreadsheet находки и покупать умнее.',
  'footer.categories': 'Категории',
  'footer.links': 'Ссылки',
  'footer.home': 'Главная',
  'footer.blog': 'Блог',
  'footer.copyright': '© 2026 YOYBUYFinds.mom — Партнёрский сайт. Мы не продаём товары напрямую.',
  'footer.privacy': 'Конфиденциальность',
  'footer.terms': 'Условия',
  'cta.goToStore': 'ПЕРЕЙТИ В МАГАЗИН',
  'cta.discover': 'ОТКРЫТЬ ПОДБОРКИ',
  'cta.shopNow': 'КУПИТЬ СЕЙЧАС',
  'backToHome': '← На главную',
  'readMore': 'Читать далее →',
};

export default common;